import pick from "lodash/pick";

export const getLibrariesData = state => state.libraries?.tablesData?.results || [];
export const getLibrariesDataPagination = state =>
  pick(state.libraries.tablesData, ["count", "next", "previous"]) || {};
